function toOrigin(urlLike) {
  if (!urlLike) return null;

  try {
    return new URL(urlLike).origin;
  } catch (_) {
    return null;
  }
}

export function getTrustedMessageOrigins() {
  const origins = [
    toOrigin(process.env.REACT_APP_CHAT_URL_DEV),
    toOrigin(process.env.REACT_APP_CHAT_URL_PROD),
  ].filter(Boolean);

  if (typeof window !== "undefined" && window.location?.origin) {
    origins.push(window.location.origin);
  }

  return Array.from(new Set(origins));
}

export function isTrustedMessageOrigin(origin) {
  if (!origin || origin === "null") return false;
  return getTrustedMessageOrigins().includes(origin);
}
